import React, { createContext, useContext, useState, useEffect } from 'react';
import Localization from '../services/Localization';
import * as Components from '../resources/Components';

const WelcomeConfigContext = createContext();

function WelcomeConfigProvider({ children, locale: initialLocale }) {
    const [WelcomeConfigLoaded, setWelcomeConfigLoaded] = useState(false);
    const [labels, setLabels] = useState({});
    const storefrontNumber = null;
    const [locale, setLocale] = useState(initialLocale || 'en_US');

    useEffect(() => {
        const fetchLabels = async () => {
            try {
                const labels = await Localization.getComponentLabels(Components.WELCOME, locale, storefrontNumber);
                setLabels(labels);
                setWelcomeConfigLoaded(true);
            } catch (error) {
                console.error("Error fetching welcome settings:", error);
            }
        };

        fetchLabels();
    }, [locale]);

    const updateLocale = (newLocale) => {
        setLocale(newLocale);
    };
    return (
        <WelcomeConfigContext.Provider value={{ WelcomeConfigLoaded, labels, updateLocale }}>
            {children}
        </WelcomeConfigContext.Provider>
    );
}

function useWelcomeConfig() {
    const context = useContext(WelcomeConfigContext);
    if (context === undefined) {
        throw new Error('useWelcomeConfig must be used within a WelcomeConfigProvider');
    }
    return context;
}

function withWelcomeConfig(Component) {
    return function WrappedComponent(props) {
        const WelcomeConfig = useWelcomeConfig();
        return <Component {...props} WelcomeConfig={WelcomeConfig} />;
    };
}

export { WelcomeConfigProvider, useWelcomeConfig, withWelcomeConfig };